<template>
  <section id="page-add-foobar">
    <div class="container">
      <div class="row">
        <clearfix :biggest="true"></clearfix>

        <div class="col-sm-12 content fb-bg-light">
          <div class="row">
            <div class="col-sm-4">
              <label for="foobar-title">Title</label><br>
              <input id="foobar-title" type="text" v-model="newFoobar.title" class="full">
            </div>
            <div class="col-sm-8">
              <label for="foobar-description">{{ $t('message.field.description') }}</label><br>
              <quill-editor id="foobar-description"
                            v-model="newFoobar.description"
                            @change="changeDescription"
                            :options="quillOptionsDescription"></quill-editor>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <b-button :size="'sm'" :variant="'secondary'" @click="saveFoobar">
                <icon name="plus-square"></icon>&nbsp;
                {{ $t('message.button.add_foobar') }}
              </b-button>
            </div>
          </div>
        </div>

        <clearfix :wide="true"></clearfix>
      </div>

      <clearfix :biggest="true"></clearfix>
    </div>
  </section>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import 'vue-awesome/icons'
  import Icon from 'vue-awesome/components/Icon.vue'
  import { quillEditor } from 'vue-quill-editor'

  import miniToastr from 'mini-toastr'

  import Clearfix from '@/components/utils/Clearfix'
  import config from './Config'

  Vue.use(VueAxios, axios)

  export default {
    data() {
      return {
        newFoobar: {},
        quillOptionsDescription: { placeholder: this.$t('message.form.placeholder.description') }
      }
    },
    methods: {
      changeDescription({html}) {
        this.newFoobar.description = html
      },
      saveFoobar() {
        Vue.axios.post(config.urls.foobar, this.newFoobar)
          .then((response) => {
            miniToastr.success(this.$t('message.text.saved'))
            this.newFoobar = {}
          })
          .catch(() => {
            miniToastr.warn(this.$t('message.error.saving_foobar_failed'))
          })
      }
    },
    components: { Clearfix, quillEditor, Icon }
  }
</script>

<style>
  #page-add-foobar {
    background: url('../../assets/img/bg/coding.jpg') center fixed no-repeat;
    background-size: cover;
    height: auto;
    margin: 0 auto;
    width: 100%;
    position: relative;
    padding: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// FoobarAdd.vue?b2cefd3a